/**
 * Convercus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TagData { 
    description?: string;
    domain: TagData.DomainEnum;
    name: string;
}
export namespace TagData {
    export type DomainEnum = 'COUPON';
    export const DomainEnum = {
        COUPON: 'COUPON' as DomainEnum
    };
}


